import { Avatar, Box, Button } from "@mui/material";
import React from "react";
import { allIcons } from "../../assets";

function ImageUploader({
  image, // Current image URL or file
  onChange, // Function to handle image change
  avatarSize = 100, // Size of the avatar (default is 100)
  buttonText = "Change", // Text for the button
}) {
  return (
    <Box position={"relative"} display={"inline-block"}>
      <Avatar src={image} sx={{ height: avatarSize, width: avatarSize }} />
      <Button
        disableRipple
        sx={{
          width: "auto",
          height: 0,
          padding: 0,
          position: "absolute",
          right: "-45px",
          bottom: 6,
          fontSize: "0.75rem",
          "&:hover": {
            background: "transparent",
          },
        }}
        endIcon={
          <img
            src={allIcons.editFillIcon}
            alt={"edit-icon"}
            width={16}
            height={17}
          />
        }
        variant="none"
        onClick={onChange} // Trigger the change function
      >
        {buttonText}
      </Button>
    </Box>
  );
}

export default ImageUploader;
